<template>
  <div class="sopRecall">
    <commonTable
      ref="commonTable"
      url="/admin/work_weixin_lc/sop_recall"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
      :extraParams="extraParams"
      @reset="() => {
        extraParams = {
          work_wx_msg_template_id: null,
          game_channel_package_id: null,
        }
      }"
      isList
      @isLoading="(val) => listLoading = val"
    >
      <template slot="summary" slot-scope="scope">
        <!-- 订单统计 -->
        <ul class="order-statistics" v-if="scope.summaryData">
          <li>
            <span>召回总数：</span>
            <em>{{ scope.summaryData.sop_count }}</em>
          </li>
          <li>
            <span>回归量：</span>
            <em>{{ scope.summaryData.recall_count }}</em>
          </li>
          <li>
            <span>召回后总充值：</span>
            <em>{{ scope.summaryData.sop_total_amount }}</em>
          </li>
        </ul>
      </template>
      <template slot="search-back">
        <el-form-item>
          <el-select
            v-model="extraParams.work_wx_msg_template_id"
            clearable placeholder="sop列表">
            <el-option
              v-for="item in sopList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="extraParams.game_channel_package_id"
            clearable placeholder="渠道包列表">
            <el-option
              v-for="item in channelPackagesList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="search" slot-scope="scope">
        <el-button
          type="success"
          plain
          icon="el-icon-download"
          @click="exportData({
            url: '/admin/work_weixin_lc/sop_recall',
            name: '召回流水',
            column,
            limit: 'per_page',
            method: 'GET',},
            {
              totalRecords: scope.totalRecords,
              searchValue: {
                ...scope.searchValue,
                ...extraParams,
              },
              total_key: 'staff_name',
              summary: true,
            })"
          class="mb1"
          :loading="listLoading">导出</el-button>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'
import { exportData } from "@/assets/js/exportData"

export default {
  name: 'sopRecall',
  data () {
    return {
      extraParams: {
        work_wx_msg_template_id: null,
        game_channel_package_id: null,
      },
      channelPackagesList: [],
      sopList: [],
      exportData,
      listLoading: false,
    }
  },
  computed: {
    column () {
      return [
        {
          label: "角色ID",
          prop: "sdk_role_id"
        },
        {
          label: "召回时间",
          prop: "time_at"
        },
        {
          label: "sop名称",
          prop: "work_wx_msg_template_name"
        },
        {
          label: "微信名",
          prop: "work_wx_external_user_name"
        },
        {
          label: "账号",
          prop: "sdk_username"
        },
        {
          label: "区服",
          prop: "sdk_zone_name"
        },
        {
          label: "角色",
          prop: "sdk_role_name"
        },
        {
          label: "总充值",
          prop: "total_amount"
        },
        {
          label: "召回总充值",
          prop: "sop_total_amount"
        },
        {
          label: "是否召回",
          prop: "is_recall",
          formatter: (row, column, cellValue) => {
            return cellValue ? '是' : '否'
          }
        },
        {
          label: "最后登陆时间",
          prop: "last_login_at"
        },
      ]
    },
    searchColumn () {
      return [
        {
          label: "角色ID",
          prop: "role_id",
          type: "input",
        },
        {
          label: "日期",
          prop: "data_start_at+data_end_at",
          type: "date",
        },
      ]
    }
  },
  components: {
    commonTable
  },
  mounted () {
    this.sopSelect()
    this.channelPackagesSelect()
  },
  methods: {
    // 渠道包 下拉选择列表
    sopSelect() {
      fetch({
        url: "/admin/work_weixin_lc/select_work_wx_msg_template_index",
        method: "GET",
      }).then((res) => {
        this.sopList = res.data.data
      })
    },
    // 渠道包 下拉选择列表
    channelPackagesSelect() {
      fetch({
        url: "/admin/game_channel_packages/channel_package_select",
        method: "GET",
      }).then((res) => {
        this.channelPackagesList = res.data.data
      })
    },
  },
}
</script>

<style lang="less">
.sopRecall .el-image-viewer__close {
  top: 100px;
  color: red;
}
</style>
